<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            itemText="codeName"
            itemValue="code"
            name="checkTypeCd"
            label="구분"
            codeGroupCd="SOP_SAFETY_TYPE_CD"
            v-model="searchParam.checkTypeCd"
          ></c-select>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="사용여부"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="점검항목 목록"
      rowKey="checkItemId"
      :columns="grid.columns"
      :editable="editable"
      :data="grid.data"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable"
            label="LBLADD"
            :showLoading="false"
            icon="add"
            @btnClicked="add"
          />
          <c-btn
            v-if="editable"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="grid.data"
            mappingType="POST"
            label="LBLSAVE"
            icon="save"
            @beforeAction="saveItem"
            @btnCallback="saveCallback"
          />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import { uid } from "quasar";
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "safety-check-item",
  data() {
    return {
      searchParam: {
        plantCd: "",
        checkTypeCd: 'SST0000001',
        useFlag: "Y",
      },
      grid: {
        columns: [
          {
            required: true,
            name: "plantCd",
            field: "plantCd",
            label: "LBLPLANT",
            align: "center",
            sortable: false,
            style: "width:100px",
            type: "plant",
          },
          // {
          //   required: true,
          //   setHeader: true,
          //   name: "checkTypeCd",
          //   field: "checkTypeCd",
          //   label: "구분",
          //   align: "left",
          //   sortable: false,
          //   style: "width:120px",
          //   type: "select",
          //   codeGroupCd: "SOP_SAFETY_TYPE_CD",
          // },
          {
            required: true,
            name: "checkItemCycleCd",
            field: "checkItemCycleCd",
            label: "주기",
            align: "center",
            style: "width:80px",
            type: "select",
            sortable: false,
            codeGroupCd: "MDM_SAFETY_CYCLE_CD",
          },
          {
            required: true,
            name: "checkItemName",
            field: "checkItemName",
            label: "점검항목",
            align: "left",
            sortable: false,
            style: "width:600px",
            type: "text",
          },
          {
            name: "useFlag",
            field: "useFlag",
            label: "사용여부",
            align: "center",
            sortable: false,
            style: "width:80px",
            type: "check",
            true: "Y",
            false: "N",
          },
          {
            name: "sortOrder",
            field: "sortOrder",
            label: "정렬순서",
            align: "center",
            sortable: false,
            style: "width:80px",
            type: "number",
          },
        ],
        data: [],
      },
      editable: true,
      useFlagItems: [
        { code: "Y", codeName: "사용" },
        { code: "N", codeName: "미사용" },
      ],
      isSave: false,
      listUrl: "",
      saveUrl: "",
      searchUrl: "",
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.sop.safetycheck.item.list.url;
      this.saveUrl = transactionConfig.sop.safetycheck.item.save.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    add() {
      this.grid.data.splice(0, 0, {
        checkItemId: uid(),
        plantCd: "",
        checkItemName: "",
        checkItemCycleCd: null,
        checkTypeCd: null,
        sortOrder: this.grid.data.length + 1,
        useFlag: "Y",
        regUserId: this.$store.getters.user.userId,
        editFlag: "C",
      });
    },
    saveItem() {
      if (this.$comm.validTable(this.grid.columns, this.grid.data)) {
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          message: "MSGSAVE", // 저장하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.isSave = !this.isSave;
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    saveCallback() {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.getList();
    },
  },
};
</script>
